import { FinancialAccountNode } from './interfaces';
import { orgsRequest } from './request';

const FINANCIAL_ACCOUNT_ROOT_QUERY = `
query FinancialAcctRoot($orgId: ID!) {
  financialAcctRoot(orgId: $orgId) {
    orgId
    orgName
    kybId
    finAcctId
    processor
    status
    acctId
    applicationId
    customerId
    createdAt
    updatedAt
    orgEin
    orgType
    stripeEnv
    finAcctId
  }
}`;

export const financialAccountRoot = async (
  orgId: string,
): Promise<FinancialAccountNode[]> => {
  const financialAccountRootRes = await orgsRequest(
    FINANCIAL_ACCOUNT_ROOT_QUERY,
    {
      orgId,
    },
  );
  const financialAccountRootJson = await financialAccountRootRes.json();
  return financialAccountRootJson.data.financialAcctRoot;
};
